import { render, staticRenderFns } from "./DialogBatchReviewMove.vue?vue&type=template&id=02eb2dfa"
import script from "./DialogBatchReviewMove.vue?vue&type=script&lang=js"
export * from "./DialogBatchReviewMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports